import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, LinearProgress } from '@mui/material';

const PREFIX = 'SplashScreen';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default || '#181818',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(3) || '12px',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2000,
  }
}));

const SplashScreen = () => {


  return (
    <Root className={classes.root}>
      <Box width={400}>
        <LinearProgress />
      </Box>
    </Root>
  );
};

export default SplashScreen;
